// Register.jsx
import React from "react";
import { Form, Input, Button } from "antd";
import AuthLayout from "./authlayout";
import brief from "../assets/brief.webp";

 function Register() {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // TODO: call your register API
    console.log("Register:", values);
  };

  return (
    <AuthLayout
      imageOnRight={true}
    >
      <div className="brand">
        <div style={{ fontSize: 36, fontWeight: 800 }}>
           <img
            src={brief}
            alt="logo"
            className="brand-logo w-50"
          />
        </div>
       
      </div>

      <h1 className="title">CREATE ACCOUNT</h1>
      <div className="subtitle">Please enter your details.</div>

      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
      >
        <div className="row">
          <div className="col-md-6">
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true, message: "Enter first name" }]}
            >
              <Input size="large" placeholder="Enter first name" />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true, message: "Enter last name" }]}
            >
              <Input size="large" placeholder="Enter last name" />
            </Form.Item>
          </div>
        </div>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Enter your email" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input size="large" placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            { required: true, message: "Enter your password" },
            { min: 6, message: "Minimum 6 characters" },
          ]}
        >
          <Input.Password size="large" placeholder="Enter your password" />
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Confirm your password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject("Passwords do not match");
              },
            }),
          ]}
        >
          <Input.Password size="large" placeholder="Enter your password" />
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" className="btn-deep" block>
            Register
          </Button>
        </Form.Item>

        <div className="text-center" style={{ color: "#ddd" }}>
          Already have an account?{" "}
          <a className="link" href="/login">
            Login
          </a>
        </div>
      </Form>
    </AuthLayout>
  );
}
export default Register;
